import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Card, Link, Container, Typography } from '@mui/material';
// hooks
// components
// sections
import AddAdminForm from './AddAdminForm';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  // minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  // backgroundColor: 'black',
  // padding: theme.spacing(12, 0),
  padding: '0px',
}));

// ----------------------------------------------------------------------

export default function AddAdmin({ closePopup, callAPI }) {
  return (
    <Container>
      <ContentStyle>
        <AddAdminForm closePopup={closePopup} callAPI={callAPI} />
      </ContentStyle>
    </Container>
  );
}
